module.exports = __webpack_public_path__ + "static/media/morHor_filled_light.5f254240.svg";